// @ts-nocheck
// @ts-ignore
class UpsellProducts extends HTMLElement {
  constructor() {
    super();
    this.set = new Set();
    this.cartUpsellMetaobjects = [];
    this.headingWithGidSet = [];
    this.productGids = [];
    this.swiper; // reference
    this.swiperElement; // reference
    this.swiperWrapperElement; // reference
    this.swiperPaginationElement; // reference
    this.swiperSlideItems = [];
    this._resizeObserver = null;
  }

  connectedCallback() {
    this.render();
    this.cacheDOM();
    this.init("upsell-products CCB");
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      try { this._resizeObserver.disconnect(); } catch (e) { }
      this._resizeObserver = null;
    }
    if (this.swiper?.destroy) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  renderSkeletonSlides() {
    const count = 3;
    return Array.from({ length: count }, () => `
          <div class="upsell-product-items__main-content upsell-product-items__main-content--skeleton swiper-slide">
            <div class="upsell-product-items__main-content__left">
              <div class="upsell-skeleton upsell-skeleton--image"></div>
              <div class="upsell-product-items__main-content__left__text-container">
                <div class="upsell-skeleton upsell-skeleton--line upsell-skeleton--line-lg"></div>
                <div class="upsell-skeleton upsell-skeleton--line"></div>
                <div class="upsell-skeleton upsell-skeleton--line upsell-skeleton--price"></div>
              </div>
            </div>
            <div class="upsell-skeleton upsell-skeleton--button"></div>
          </div>
        `).join('');
  }

  render() {
    if (JSON.parse(this.dataset.cartUpsellMetaobjects || '[]').length > 0) {
      this.innerHTML = `

        <div class="upsell-product-items__container">
          <h2 class="upsell-product-items__title athletics-semibold">
            <span class="upsell-product-items__title__first-half">Training Mesh Bag.</span>
            <span class="upsell-product-items__title__second-half"> Keep training aids intact.</span>
          </h2>

          <div class="upsell-product-items swiper mySwiper">
            <div class="swiper-wrapper">
              ${this.renderSkeletonSlides()}
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      `;
    }
  }

  cacheDOM() {
    this.titleElement = this.querySelector('.upsell-product-items__title');
    this.swiperElement = this.querySelector('.upsell-product-items');
    this.swiperWrapperElement = this.querySelector('.swiper-wrapper');
    this.swiperPaginationElement = this.querySelector('.swiper-pagination');
  }

  async init(invoker) {
    this.cartUpsellMetaobjects = JSON.parse(this.dataset.cartUpsellMetaobjects || '[]');


    let targetObj = this.cartUpsellMetaobjects[0];
    if (!targetObj || !targetObj.heading) {
      return;
    }
    let headingParts = targetObj.heading.split(".")
    if (!targetObj || !targetObj.heading) {
      return;
    }

    if (headingParts.length >= 2) {
      let firstHalf = headingParts[0];
      let secondHalf = headingParts[1];
      this.titleElement.innerHTML = `<span class="upsell-product-items__title__first-half">${firstHalf}</span>
            <span class="upsell-product-items__title__second-half">${secondHalf}</span>`;
    } else {
      this.titleElement.innerHTML = `<span class="upsell-product-items__title__first-half">${targetObj.heading}</span>`;
    }



    this.cartUpsellMetaobjects.forEach(item => {
      if (!this.set.has(item.product)) {
        this.headingWithGidSet.push(item);
        this.set.add(item.product); // product is already a Product GID
      }
    });

    this.productGids = Array.from(this.set);


    // fetch data
    const products = await this.fetchData(this.productGids);
    this.swiperSlideItems = products;
    if (this.swiperSlideItems.length == 0) {
      this.innerHTML = ``;
      return;
    }
    // destroy any existing swiper (e.g. from skeleton) so only one instance exists
    if (this.swiper?.destroy) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    // hydrate slides
    this.hydrateSlides(this.swiperSlideItems);
    // init swiper once the element is visible/sized (cart drawer opens/animates)
    await this.initSwiperWhenReady();
    if (this.swiper?.on) {
      this.swiper.on('slideChange', () => {
        const activeSlide = this.swiper?.slides?.[this.swiper.activeIndex];
        const productGid = activeSlide?.dataset?.productGid;
        if (productGid) this.handleTitleChange(productGid);
      });

      // Ensure title matches initial active slide (esp. after reset/re-init)
      const initialSlide = this.swiper?.slides?.[this.swiper.activeIndex];
      const initialGid = initialSlide?.dataset?.productGid;
      if (initialGid) this.handleTitleChange(initialGid);
    }
  }

  async fetchData(productGids) {
    const STOREFRONT_ACCESS_TOKEN = window.storefrontAccessToken;
    const STORE_DOMAIN = window.storeDomain;
    productGids = productGids.map(id => `gid://shopify/Product/${id}`).filter(Boolean);



    const endpoint = `https://${STORE_DOMAIN}/api/2026-01/graphql.json`;

    const query = `
        query getProducts($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title,
              handle,
              featuredImage {
                url
                altText
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              highlights: metafield(namespace: "neo", key: "highlights") {
                value
              }
              variants(first: 1) {
                nodes {
                  id
                }
              }
            }
          }
        }
      `;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: { ids: productGids },
      }),
    });


    const { data, errors } = await response.json();

    if (errors) {
      return [];
    }

    return data.nodes
      .map(product => {
        if (!product) return null;

        let highlights = [];
        if (product.highlights?.value) {
          try {
            highlights = JSON.parse(product.highlights.value);
          } catch {
            highlights = [];
          }
        }

        return {
          id: product.id,
          variantId: product.variants.nodes[0]?.id || null,
          title: product.title,
          handle: product.handle,
          featuredImage: product.featuredImage?.url || null,
          price: product.priceRange.minVariantPrice.amount,
          currency: product.priceRange.minVariantPrice.currencyCode,
          highlights,
        };
      })
      .filter(Boolean);
  }

  createSlide(product) {
    const slide = document.createElement('div');
    slide.dataset.productGid = product.id;
    slide.dataset.variantId = product.variantId;
    slide.className = 'swiper-slide';
    let slideContentContainer = document.createElement('div');
    slideContentContainer.className = 'upsell-product-items__main-content';
    // Left container
    const leftContainer = document.createElement('div');
    leftContainer.className = 'upsell-product-items__main-content__left';

    // Image container
    const imageContainer = document.createElement('a');
    imageContainer.className = 'upsell-product-items__main-content__left__image-container';
    imageContainer.href = `/products/${product.handle}`;

    const img = document.createElement('img');
    img.src = product.featuredImage ? `${product.featuredImage}&width=70` : '';
    img.alt = product.title || '';
    img.loading = 'lazy';
    imageContainer.appendChild(img);

    // Text container
    const textContainer = document.createElement('div');
    textContainer.className = 'upsell-product-items__main-content__left__text-container';

    const title = document.createElement('a');
    title.className = 'upsell-product-title athletics-bold';
    title.textContent = product.title || '';
    title.href = `/products/${product.handle}`;

    const description = document.createElement('a');
    description.className = 'upsell-product-description athletics-medium';
    description.href = `/products/${product.handle}`;
    const highlightsText = product.highlights && product.highlights.length > 0
      ? product.highlights.join(' | ')
      : 'Sport wear | Enviroment freindly | Suits all skin types';
    description.textContent = highlightsText;

    const price = document.createElement('a');
    price.className = 'upsell-product-price athletics-bold';
    price.textContent = `₹ ${this.formatPrice(product.price) || 'Unavailable product'}`;
    price.href = `/products/${product.handle}`;

    textContainer.appendChild(title);
    textContainer.appendChild(description);
    textContainer.appendChild(price);

    leftContainer.appendChild(imageContainer);
    leftContainer.appendChild(textContainer);

    // Button
    const button = document.createElement('button');
    button.className = 'upsell-product-items__main-content__right athletics-semibold';
    button.textContent = '+ Add';

    button.addEventListener('click', () => {
      if (!product.variantId) {
        return;
      }
      this.handleAddToCart(product.variantId, button);
    });

    slideContentContainer.appendChild(leftContainer);
    slideContentContainer.appendChild(button);
    slide.appendChild(slideContentContainer);

    return slide;
  }

  async handleAddToCart(variantId, buttonEl) {
    if (this.swiper?.autoplay?.stop) {
      this.swiper.autoplay.stop();
    }
    if (buttonEl) {
      buttonEl.disabled = true;
      buttonEl.textContent = 'Adding...';
    }

    if (variantId.includes('gid://')) {
      variantId = parseInt(variantId.split('/').pop(), 10);
    }

    try {
      const cartItems = window.latestCartData?.items || [];
      const existingItem = cartItems.find(item => item.variant_id === variantId || item.id === variantId); // fix 1

      if (existingItem) {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingItem.key,
            quantity: existingItem.quantity + 1
          }),
        });

        if (!response.ok) throw new Error('Failed to update cart item quantity.');

        const data = await response.json();
        window.latestCartData = data;

      } else {
        const formData = {
          items: [{
            id: variantId, // fix 2
            quantity: 1
          }]
        };

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          try {
            if (typeof window !== 'undefined' && typeof window.auditzyTrackingScript === 'function') {
              window.auditzyTrackingScript();
            } else if (typeof auditzyTrackingScript === 'function') {
              auditzyTrackingScript();
            }
          } catch (err) {
            console.warn('auditzyTrackingScript failed:', err);
          }
        } else {
          throw new Error('Failed to add item to cart.');
        }

        const data = await response.json();
        window.latestCartData = window.latestCartData || {};
        window.latestCartData.items = window.latestCartData.items || [];
        window.latestCartData.items.unshift(...data.items);
        // Sync full cart from server so item_count, total, etc. are correct
        const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
        if (cartRes.ok) {
          window.latestCartData = await cartRes.json();
        }

      }

      if (buttonEl) buttonEl.textContent = '✓ Added';

      await this.updateCartDrawer();

    } catch (error) {
      if (buttonEl) buttonEl.textContent = 'Error';
      if (typeof window.toastMessage.init === 'function') {
        window.toastMessage.init(
          `Can not add product: ${error.message}`,
          "error",
          "top center",
          "right to left",
          3000
        );
      }

    } finally {
      // setTimeout(() => {
      if (buttonEl) {
        buttonEl.disabled = false;
        buttonEl.textContent = '+ Add';
        // if(document.querySelector('custom-from-your-wishlist')?.reset()){
        //   document.querySelector('custom-from-your-wishlist')?.reset()
        // }
      }
      // }, 500);
    }
  }

  /**
   * Re-renders the cart drawer so it shows the updated cart.
   * Uses section rendering API (or fallback fetch) to replace cart drawer HTML.
   */
  async updateCartDrawer() {
    const cartItemsComponent = document.querySelector('cart-items-component');
    const sectionId = cartItemsComponent?.dataset?.sectionId;
    if (!sectionId) {
      return;
    }
    try {
      const { sectionRenderer } = await import('@theme/section-renderer');
      await sectionRenderer.renderSection(sectionId, { cache: false });

      if (typeof window.syncCartDrwer === 'function') {
        window.syncCartDrwer();
      }
    } catch (e) {
      try {
        const url = new URL(window.location.href);
        const normalizedId = sectionId.replace(/^shopify-section-/, '');
        url.searchParams.set('section_id', normalizedId);
        const res = await fetch(url.toString());
        if (!res.ok) return;
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newEl = doc.getElementById(`shopify-section-${normalizedId}`);
        const existingEl = document.getElementById(`shopify-section-${normalizedId}`);
        if (existingEl && newEl) {
          existingEl.innerHTML = newEl.innerHTML;
        }
        if (typeof ReloadSmartWishlist === 'function') {
          ReloadSmartWishlist();
        }
      } catch (fallbackErr) {
        console.error('UpsellProducts: cart drawer re-render fallback failed', fallbackErr);
      }
    }
  }


  hydrateSlides(products) {
    if (!products || products.length === 0) {
      return;
    }
    // Clear existing slides
    this.swiperWrapperElement.innerHTML = '';
    // Create and append slides
    products.forEach(product => {
      const slide = this.createSlide(product);
      this.swiperWrapperElement.appendChild(slide);
    });

    if (products.length < 2) {
      this.swiperElement.querySelector('.swiper-pagination').style.display = 'none';
    }
  }

  handleTitleChange(productGid) {
    productGid = productGid.split('/').pop();

    if (!productGid) return;

    let targetObj = this.headingWithGidSet.find(item => item.product === productGid);

    if (!targetObj || !targetObj.heading) return;
    let headingParts = targetObj.heading.split(".")

    if (headingParts.length >= 2) {
      let firstHalf = headingParts[0];
      let secondHalf = headingParts[1];
      this.titleElement.innerHTML = `<span class="upsell-product-items__title__first-half athletics-semibold">${firstHalf}</span>
            <span class="upsell-product-items__title__second-half">${secondHalf}</span>`;
    } else {
      this.titleElement.innerHTML = `<span class="upsell-product-items__title__first-half athletics-semibold">${targetObj.heading}</span>`;
    }
  }

  initSwiper() {
    if (!this.swiperElement || !this.swiperWrapperElement?.children?.length) return;
    this.swiper = new Swiper(this.swiperElement, {
      pagination: {
        el: this.swiperPaginationElement,
        clickable: true,
      },
      slidesPerView: 1,
      speed: 1000,
      autoplay: {
        delay: 500,
        // disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      loop: true,
      simulateTouch: true,
      touchRatio: 1,
      threshold: 5,
      breakpoints: {
        601: {
          slidesPerView: 1.4,
          spaceBetween: 20,
        }
      }
    });

    // If initialized while hidden, Swiper often needs a forced update to compute sizes.
    this.kickSwiper();
  }

  async initSwiperWhenReady() {
    if (!this.swiperElement || !this.swiperWrapperElement?.children?.length) return;

    // Wait until the slider has a real layout size (common issue inside cart drawer).
    await this.waitForElementToBeSized(this.swiperElement, 2500);

    // Initialize once. If it already exists, just "kick" it.
    if (!this.swiper) {
      this.initSwiper();
    } else {
      this.kickSwiper();
    }

    // Keep it healthy if drawer animation/responsive changes adjust width later.
    if (!this._resizeObserver && typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => this.kickSwiper());
      try { this._resizeObserver.observe(this.swiperElement); } catch (e) { }
    }
  }

  kickSwiper() {
    if (!this.swiper) return;

    // Defer a bit so CSS transitions (drawer open) settle.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try { this.swiper.update(); } catch (e) { }
        try { this.swiper.slideToLoop?.(this.swiper.realIndex || 0, 0); } catch (e) { }
        try { this.swiper.autoplay?.start?.(); } catch (e) { }
      });
    });
  }

  waitForElementToBeSized(el, timeoutMs = 2000) {
    return new Promise(resolve => {
      if (!el) return resolve(false);

      const start = Date.now();
      const check = () => {
        const w = el.offsetWidth || 0;
        const h = el.offsetHeight || 0;
        if (w > 0 && h > 0) return resolve(true);
        if (Date.now() - start > timeoutMs) return resolve(false);
        requestAnimationFrame(check);
      };

      check();
    });
  }

  reset() {
    // cleanup
    this.set.clear();
    this.cartUpsellMetaobjects = [];
    this.headingWithGidSet = [];
    this.productGids = [];

    // destroy swiper if exists
    if (this.swiper?.destroy) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    // re-init
    this.connectedCallback();
  }

  formatPrice(price) {
    const formatted = parseFloat(price).toFixed(2); // ensures 2 decimal places always
    if (formatted.endsWith(".00")) {
      return formatted.replace(".00", ""); // 14.00 → 14
    }
    return formatted; // 14.70 → 14.70 | 14.79 → 14.79
  }


}

customElements.define('upsell-products', UpsellProducts);

